<template>
  <div class="userCenter">
    <div class="dashboard">
      <div class="head">
        <div class="head_name">用户名：{{ $store.state.nickname }}</div>
        <div class="head_status">申请状态：<span>{{ userInfo.is_check == '1' ? '申请成功' : '暂未申请' }}</span></div>
        <div class="head_btn" @click="editFn">信息修改</div>
        <div class="head_btn" @click="feedbackFn" style="margin-left: 280px;cursor: pointer;">我要反馈</div>
      </div>
      <div class="btn_list">
        <div class="btn_item" @click="publish">发布需求</div>
        <div class="btn_item" @click="displayFn">申请资格</div>
      </div>
      <el-tag type="warning">我的接单</el-tag>
      <el-table :data="userOrder" style="width: 100%">
        <el-table-column prop="title" label="标题" width="180">
        </el-table-column>
        <el-table-column prop="price" label="价格">
        </el-table-column>
        <el-table-column prop="mobile" label="手机号">
        </el-table-column>
        <el-table-column prop="number" label="人数">
        </el-table-column>
        <el-table-column prop="date" label="截止日期">
          <template #default="{ row }">{{ formatDate(row.date) }}</template>
        </el-table-column>
        <el-table-column prop="date" label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button type="primary" size="mini" @click="finish(row.id)" :disabled="row.type == '2'">{{ row.type == '1'
              ? '完结' : '已完结'
            }}</el-button>
            <el-button type="danger" size="mini" @click="abandon(row.id)" :disabled="row.type == '2'">退单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-tag type="danger" style="margin-top: 50px;">我的收藏</el-tag>
      <el-table :data="likeList" style="width: 100%">
        <el-table-column prop="title" label="标题" width="180">
        </el-table-column>
        <el-table-column prop="price" label="价格">
        </el-table-column>
        <!-- <el-table-column prop="mobile" label="手机号"> -->
        </el-table-column>
        <el-table-column prop="number" label="人数">
        </el-table-column>
        <el-table-column prop="date" label="截止日期">
          <template #default="{ row }">{{ formatDate(row.date) }}</template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 右侧悬浮审核按钮+角标 -->
    <div  class="float-audit-btn" @click="openAuditDialog">
      <span>审核</span>
      <!-- 角标：数量为0隐藏 -->
      <i v-if="auditCount > 0&&userInfo.level === '99'" class="badge">{{ auditCount > 99 ? '99+' : auditCount }}</i>
    </div>

    <!-- 发布待审核弹窗 -->
    <el-dialog title="审核" :visible.sync="auditDialogVisible" width="85%" @close="resetAudit">
      <el-table :data="auditList" border>
        <el-table-column label="标题" prop="title" />
        <el-table-column label="价格" prop="price" />
        <el-table-column label="手机号" prop="mobile" />
        <el-table-column label="人数" prop="number" />
        <el-table-column label="截止日期" prop="date">
          <template #default="{ row }">{{ formatDate(row.date) }}</template>
        </el-table-column>
        <el-table-column label="任务描述" prop="nickname" />
        <el-table-column label="技能要求" prop="totalPrice" />
        <!-- type:0未审核，1审核通过，2接单，3完结，5驳回审核 -->
        <el-table-column label="状态" prop="type">
          <template #default="{ row }">
            {{ row.type == '0' ? '待审核' : row.type == '1' ? '审核通过' : row.type == '2' ? '接单' : row.type == '3' ? '完结' : '已完结' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="userInfo.level === '99'" align="center" width="180">
          <template #default="{ row }">
            <el-button size="mini" type="success" @click="passAudit(row.id)">通过</el-button>
            <el-button size="mini" type="danger" @click="rejectAudit(row.id)">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="发布需求" :visible.sync="centerDialogVisible" width="30%" center @close="close">
      <el-form ref="form" :model="params" label-width="80px">
        <el-form-item label="标题" :rules="titleRules" prop="title">
          <el-input v-model="params.title"></el-input>
        </el-form-item>
        <el-form-item label="价格" :rules="priceRules" prop="price">
          <el-input v-model="params.price"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" :rules="mobileRules">
          <el-input v-model="params.mobile"></el-input>
        </el-form-item>
        <el-form-item label="人数" prop="number" :rules="numberRules">
          <el-input v-model="params.number"></el-input>
        </el-form-item>
        <el-form-item label="截止日期" prop="date" :rules="dateRules">
          <el-date-picker type="date" placeholder="选择日期" v-model="params.date" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="任务描述" :rules="nicknameRules" prop="nickname">
          <el-input v-model="params.nickname" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="技能要求" prop="totalPrice" :rules="totalPriceRules">
          <el-input v-model="params.totalPrice" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 制作展厅 -->
    <el-dialog title="申请资格" :visible.sync="displayVisible" width="30%" center @close="close">
      <el-form ref="displayform" :model="displayParams" label-width="80px">
        <el-form-item label="标题" :rules="titleRules" prop="title">
          <el-input v-model="displayParams.title"></el-input>
        </el-form-item>
        <el-form-item label="业务类型" :rules="sortRules" prop="sort">
          <el-input v-model="displayParams.sort"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile" :rules="mobileRules">
          <el-input v-model="displayParams.mobile"></el-input>
        </el-form-item>
        <el-form-item label="资质图片" :rules="imgRules" prop="img">
          <div class="imgUloadBox">
            <Imgupload :url="displayParams.img" @imgUrlFn="imgUrlFn2" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="displayVisible = false">取 消</el-button>
        <el-button type="primary" @click="displayConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 信息修改 -->
    <el-dialog title="信息修改" :visible.sync="editVisible" width="30%" center @close="close">
      <el-form ref="editform" :model="userInfo" label-width="80px">
        <el-form-item label="昵称" :rules="nicknameRules" prop="nickname">
          <el-input v-model="userInfo.nickname"></el-input>
        </el-form-item>
        <el-form-item label="用户头像" :rules="logoRules" prop="logo">
          <div class="imgUloadBox">
            <Imgupload :url="userInfo.logo" @imgUrlFn="imgUrlFn" />
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button type="primary" @click="editConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 我要反馈 -->
    <el-dialog title="我要反馈" :visible.sync="feedbackVisible" width="30%" center @close="close">
      <el-form ref="feedbackForm" :model="feedbackParams" label-width="80px">
        <el-form-item label="反馈内容" :rules="feedbackRules.content" prop="content">
          <el-input v-model="feedbackParams.content" type="textarea" placeholder="请详细描述您的问题或建议"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" :rules="feedbackRules.mobile" prop="mobile">
          <el-input v-model="feedbackParams.mobile" placeholder="请留下您的手机号，方便我们联系您"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="feedbackVisible = false">取 消</el-button>
        <el-button type="primary" @click="feedbackConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { publish_informationApi, take_information_listApi, userInfoApi, abandonOrderApi, update_user_infoApi, applyDisplayApi, finishOrderApi, likeListApi, feedbackApi, checkListApi, checkActionApi } from "../api/index";
import myform from "./components/myform.vue";
import Imgupload from '../components/Imgupload'
export default {
  data() {
    return {
      // 新增待审核相关
      auditCount: 0,
      auditDialogVisible: false,
      auditList: [],
      userInfo: {},
      centerDialogVisible: false,
      displayVisible: false,
      editVisible: false,
      // 新增：反馈弹窗相关
      feedbackVisible: false,
      feedbackParams: {
        content: '',
        mobile: ''
      },
      feedbackRules: {
        content: [
          { required: true, message: '请输入反馈内容', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确手机号', trigger: 'blur' }
        ]
      },
      params: {
        title: '',
        nickname: "",//任务描述
        price: null,
        mobile: null,
        number: null,
        totalPrice: null,//技能要求
        date: null,
      },
      displayParams: {
        title: '',
        sort: '',
        mobile: null,
        img: ""
      },
      titleRules: [
        { required: true, message: '请输入标题', trigger: 'blur' },
      ],
      nicknameRules: [
        { required: true, message: '请输入任务描述', trigger: 'blur' },
      ],
      priceRules: [
        { required: true, message: '请输入价格', trigger: 'blur' },
        { pattern: /^[0-9~]+$/, message: '价格只能是数字或~单位：元/张', trigger: 'blur' },
      ],
      mobileRules: [
        { required: true, message: '请输入手机号', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确手机号', trigger: 'blur' },
      ],
      numberRules: [
        { required: true, message: '请输入人数', trigger: 'blur' },
        { pattern: /^\d+$/, message: '人数只能是数字', trigger: 'blur' }
      ],
      totalPriceRules: [
        { required: true, message: '请输入技能要求', trigger: 'blur' },
      ],
      dateRules: [
        { required: true, message: '请输入截止日期', trigger: 'blur' },
      ],
      sortRules: [
        { required: true, message: '请输入制作类型', trigger: 'blur' },
      ],
      logoRules: [
        { required: true, message: '请输入制作类型', trigger: 'blur' },
      ],
      imgRules: [
        { required: true, message: '请上传展厅图片', trigger: 'blur' },
      ],
      userOrder: [],
      likeList: [],
      checkActionParams: {
        "id": "",
        "type": ""//type:0未审核，1审核通过，2接单，3完结，5驳回审核
      }
    };
  },
  components: {
    myform,
    Imgupload
  },
  created() {
    this.getUserOrder()
    this.getUserInfo()
    this.getLikeList()
    // 获取待审核列表
    this.getAuditNum()
  },
  methods: {
    // 打开审核弹窗、加载待审核列表
    async openAuditDialog() {
      this.auditDialogVisible = true
      // 后端接口替换：const res = await getAuditListApi()
      // this.auditList = res.data.data
      // 测试假数据
      // this.auditList = [
      //   { id: 1, title: "海报设计", price: "200", mobile: "13800138000", number: "2", date: "2025-12-30", nickname: "设计电商海报", totalPrice: "PS、AI" }
      // ]
    },
    // 通过审核
    passAudit(id) {
      this.checkActionParams.id = id
      this.checkActionParams.type = 1
      this.$confirm('确定通过该需求审核？', '提示', { type: 'success' }).then(async () => {
        const res = await checkActionApi(this.checkActionParams)
        if (res.data.code == 1) {
          this.auditDialogVisible = false
          this.$message.success('审核通过,已发布')
        } else {
          this.$message.error('审核通过失败')
        }
        // this.openAuditDialog()
        this.getAuditNum()
      }).catch(() => { })
    },
    // 驳回审核
    rejectAudit(id) {
      this.checkActionParams.id = id
      this.checkActionParams.type = 5
      this.$confirm('确定驳回该需求？驳回后不可恢复', '警告', { type: 'warning' }).then(async () => {
        // 替换驳回接口 await rejectAuditApi({id})
        const res = await checkActionApi(this.checkActionParams)
        if (res.data.code == 1) {
          this.auditDialogVisible = false
          this.$message.success('操作成功，已驳回')
        } else {
          this.$message.error('操作失败')
        }
        // this.openAuditDialog()
        this.getAuditNum()
      }).catch(() => { })
    },
    // 关闭弹窗清空列表
    resetAudit() {
      // this.auditList = []
    },
    // 获取待审核数量（角标）
    async getAuditNum() {
      // 后端接口：const res = await auditCountApi()
      // this.auditCount = res.data.data.count
      const res = await checkListApi()
      console.log("res", res);
      this.auditList = res.data.data.reverse()
      this.auditCount = res.data.data.length
    },
    // 修改：打开反馈弹窗
    feedbackFn() {
      this.feedbackVisible = true;
    },
    // 新增：提交反馈
    feedbackConfirm() {
      this.$refs.feedbackForm.validate(async (valid) => {
        if (valid) {
          // 这里可以添加提交反馈的API调用逻辑
          console.log('反馈内容：', this.feedbackParams);
          // 调用反馈API
          const res = await feedbackApi(this.feedbackParams)
          if (res.data.code == 1) {
            this.$message({
              type: 'success',
              message: '反馈提交成功！我们会尽快处理。'
            });
            this.feedbackVisible = false;
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }

          this.feedbackVisible = false;
        }
      });
    },
    async getLikeList() {
      const res = await likeListApi({
        "page": {
          "page_num": "1",
          "page_limit": "20"
        },
        "map": {
        }
      })
      this.likeList = res.data.data.map(item => item.information_info)
    },
    async editConfirm() {
      const res = await update_user_infoApi(this.userInfo)
      if (res.data.code === 1) {
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        this.editVisible = false
      } else {
        this.$message({
          type: 'success',
          message: '修改失败!'
        })
      }
    },
    async editFn() {
      this.editVisible = true
    },
    abandon(id) {

      this.$confirm('此操作将退单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        const res = await abandonOrderApi({ id: id })
        if (res.data.code === 1) {
          this.getUserOrder()
          this.$message({
            type: 'success',
            message: '退单成功!'
          })
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    finish(id) {
      this.$confirm('您是否已完结?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await finishOrderApi({ id: id })
        if (res.data.code === 1) {
          this.getUserOrder()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    displayFn() {
      this.displayVisible = true
    },
    displayConfirm() {
      this.$refs.displayform.validate(async (valid) => {
        if (valid) {
          const res = await applyDisplayApi({})
          if (res.data.code === 1) {
            this.getUserOrder()
            this.$message({
              type: 'success',
              message: res.data.msg
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
          this.displayVisible = false
        }
      });
    },
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.params.date = moment(this.params.date).format("YYYY-MM-DD")
          const res = await publish_informationApi(this.params)
          console.log("res", res);
          if (res.data.code == 1) {
            this.$message.success('操作成功，已提交审核');
            this.getUserOrder()
            this.getAuditNum()
          } else {
            this.$message.error('操作失败');
          }
          this.centerDialogVisible = false
        }
      });
    },
    async getUserOrder() {
      const res = await take_information_listApi()
      if (res.data.code === 1) {
        this.userOrder = res.data.data
      }
    },
    publish() {
      this.centerDialogVisible = true
    },
    // 修改：增加重置反馈表单的逻辑
    close() {
      this.getUserInfo()
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      if (this.$refs.displayform) {
        this.$refs.displayform.resetFields()
      }
      if (this.$refs.feedbackForm) {
        this.$refs.feedbackForm.resetFields()
      }
    },
    async getUserInfo() {
      const res = await userInfoApi({})
      this.$store.commit('setNickname', res.data.data.nickname)
      this.userInfo = res.data.data
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD")
    },
    imgUrlFn(imgurl) {
      this.userInfo.logo = imgurl
    },
    imgUrlFn2(imgurl) {
      this.displayParams.img = imgurl
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  margin-bottom: 0;
}

.userCenter {
  padding-top: 70px;
  padding-bottom: 50px;
  position: relative;
}

/* 右侧悬浮审核按钮样式 */
.float-audit-btn {
  position: fixed;
  right: 40px;
  bottom: 120px;
  width: 60px;
  height: 60px;
  background: #3669FF;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(54, 105, 255, 0.35);
  z-index: 999;

  &:hover {
    background: #2958e8;
  }

  .badge {
    position: absolute;
    top: -5px;
    right: -5px;
    min-width: 22px;
    height: 22px;
    background: #f56c6c;
    border-radius: 11px;
    font-size: 12px;
    text-align: center;
    line-height: 22px;
    padding: 0 4px;
  }
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f4f4f9;
}

/* 操作面板容器 */
.dashboard {
  max-width: 1200px;
  margin: 50px auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 50px;
}

/* 面板头部样式 */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* 用户名样式 */
.username {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

/* 退出按钮样式 */
.logout-btn {
  background-color: #e74c3c;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logout-btn:hover {
  background-color: #c0392b;
}

/* 申请状态区域样式 */
.application-status {
  background-color: #f9f9f9;
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  padding: 20px;
}

.application-status h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #555;
}

.status-value {
  font-size: 16px;
  color: #777;
}

.dashboard {
  .head {
    display: flex;
    align-items: center;

    .head_name {
      font-size: 29px;
      color: #000000;
    }

    .head_status {
      font-size: 22px;
      color: #000000;
      margin: 0 77px 0 56px;

      span {
        font-size: 22px;
        color: #3DC26E;
      }
    }

    .head_btn {
      width: 102px;
      height: 36px;
      background: #3669FF;
      border-radius: 4px 4px 4px 4px;
      font-size: 15px;
      color: #FFFFFF;
      text-align: center;
      line-height: 36px;
    }
  }

  .btn_list {
    display: flex;
    align-items: center;
    margin: 22px 0 38px 0;

    .btn_item {
      width: 102px;
      height: 36px;
      background: #D1DCFF;
      border-radius: 4px 4px 4px 4px;
      font-size: 15px;
      color: #3669FF;
      text-align: center;
      line-height: 36px;
      font-weight: bold;
      margin-right: 22px;
    }
  }
}
</style>